require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// ./~/material-ui/~/core-js/library/modules/es7.symbol.observable.js
// module id = 605
// module chunks = 0